import { NgModule } from "@angular/core";
import { PrimeNgModule } from "../primeng.module";
import { CommonModule } from "@angular/common";
import { NhsLoginButtonComponent } from "./components/nhs-login-button.component";
import { NhsLogoSvgComponent } from "./components/nhs-logo-svg.component";

@NgModule({
    declarations: [NhsLoginButtonComponent, NhsLogoSvgComponent],
    exports: [NhsLoginButtonComponent, NhsLogoSvgComponent],
    imports: [CommonModule, PrimeNgModule]
})
export class NhsLoginModule {}
